import { createContext, type Dispatch, type SetStateAction } from "react";

export const FullscreenContext = createContext<[boolean, Dispatch<SetStateAction<boolean>>]>([false, () => {}]);
